import type { INormalOfferPricesResponse } from 'shared/repositories/mortgage-subsidised-offers/entities/get_normal_offers_prices/NormalOfferPricesResponse';
import type { IMappers } from 'shared/repositories/mortgage-subsidised-offers/v1/get-normal-offer-prices';
import type { IEtazhiBlackFridayPricesData } from 'shared/types/etazhiBlackFriday';

export const map200Response = (response: INormalOfferPricesResponse): IEtazhiBlackFridayPricesData => {
  return response.offerPrices as IEtazhiBlackFridayPricesData;
};

export const map400Response = (): null => null;

export const mappers: IMappers<IEtazhiBlackFridayPricesData, null> = {
  200: map200Response,
  400: map400Response,
};
